import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function requestCode(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.forgot(email.trim());
      setStep('code');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }
  async function reset(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.forgotConfirm(email.trim(), code.trim(), password);
      navigate('/login', { state: { email: email.trim(), notice: 'Password reset. Sign in with your new password.' } });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 440 }}>
      <h1>Forgot password</h1>
      {step === 'email' ? (
        <form className="card grid" style={{ gap: 12, marginTop: 20 }} onSubmit={requestCode}>
          <p className="muted small">We will email a verification code to the address on your account.</p>
          <label className="field">
            Email
            <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          {error && <p className="badge bad">{error}</p>}
          <div>
            <button className="btn primary" disabled={busy}>
              {busy ? 'Sending…' : 'Send code'}
            </button>
          </div>
        </form>
      ) : (
        <form className="card grid" style={{ gap: 12, marginTop: 20 }} onSubmit={reset}>
          <p className="muted small">If an account exists for {email}, a code is on its way. Enter it with your new password.</p>
          <label className="field">
            Verification code
            <input className="input mono" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} required />
          </label>
          <label className="field">
            New password
            <input className="input" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} />
          </label>
          {error && <p className="badge bad">{error}</p>}
          <div className="row">
            <button className="btn primary" disabled={busy}>
              {busy ? 'Resetting…' : 'Reset password'}
            </button>
            <button type="button" className="btn" onClick={() => setStep('email')}>
              Back
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
